export function common() {
  

  //フォームエラー時
  jQuery(function(){
    $(function(){
      // errorクラスのspan要素を持つ親p要素にerror-pinkクラスを適用
      $("td:has('span.error')").addClass("error-pink");
    });
  });

  //TOP hero 動画の再生・停止
  jQuery(function(){

    const indexHero = document.querySelector('.p-indexHero');
    if(indexHero) {
      var target = document.querySelector('.p-indexHero');
      var video = document.querySelector('.p-indexHero_movie');
    
      function checkClasses() {
        if ($(target).hasClass('active') && $(target).hasClass('fp-completely')) {
          video.play();
        } else {
          video.pause();
        }
      }
    
      checkClasses(); // 初回状態チェック
    
      var observer = new MutationObserver(function(mutationsList) {
        mutationsList.forEach(function(mutation){
          if (mutation.attributeName === 'class') {
            checkClasses();
          }
        });
      });
    
      observer.observe(target, { attributes: true });
    }
    
  });

  jQuery(function(){
    $('.ac_panel .ac_heading').on('click', function () {
      $(this).next('.ac_content').slideToggle();
      $(this).toggleClass('is-active');
    });
  });
}